import React from 'react';
import { Flight, Package } from '../../utils/types';
import { packages } from '../../utils/mockData';
import PackageCard from '../search/PackageCard';
interface RecommendedPackagesProps {
  selectedFlight: Flight | null;
  onSelectPackage: (pkg: Package) => void;
}
const RecommendedPackages: React.FC<RecommendedPackagesProps> = ({
  selectedFlight,
  onSelectPackage
}) => {
  // Filter packages that match the selected flight's destination
  const matchingPackages = packages.filter(pkg => selectedFlight && pkg.flight.arrivalCity === selectedFlight.arrivalCity);
  if (matchingPackages.length === 0) return null;
  return <div className="mt-12 mb-6" data-id="element-16">
      <div className="border-t border-gray-200 pt-8" data-id="element-17">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-18">
          Recommended Flight + Hotel Packages
        </h2>
        <p className="text-gray-600 mb-6" data-id="element-19">
          Save money by booking one of these pre-selected flight and hotel
          packages.
        </p>
        <div className="space-y-6" data-id="element-20">
          {matchingPackages.map(pkg => <div key={pkg.id} onClick={() => onSelectPackage(pkg)} className="cursor-pointer hover:shadow-md transition-shadow" data-id="element-21">
              <PackageCard package={pkg} data-id="element-22" />
            </div>)}
        </div>
      </div>
    </div>;
};
export default RecommendedPackages;